var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import _ from 'lodash';
import { Subject } from 'rxjs/Subject';
import { Protocol } from './protocol';
var WebSocketProtocol = (function (_super) {
    __extends(WebSocketProtocol, _super);
    function WebSocketProtocol(url, loggerService, config, protocols) {
        var _this = _super.call(this, loggerService, config) || this;
        _this.url = url;
        _this.protocols = protocols;
        _this.sendQueue = [];
        _this.readyStateConstants = {
            CONNECTING: 0,
            OPEN: 1,
            // tslint:disable-next-line:object-literal-sort-keys
            CLOSING: 2,
            CLOSED: 3,
            RECONNECT_ABORTED: 4
        };
        _this.normalCloseCode = 1000;
        _this.reconnectableStatusCodes = [WebSocketProtocol.AVAILABLE_FOR_USER_WS_CLOSE_STATUS];
        var match = new RegExp('wss?://').test(url.url);
        if (!match) {
            throw new Error('Invalid url provided [' + url.url + ']');
        }
        _this.reconnectIfNotNormalClose =
            config && config.reconnectIfNotNormalClose ? config.reconnectIfNotNormalClose : false;
        _this.dataStream = new Subject();
        return _this;
    }
    WebSocketProtocol.prototype.connect = function (force) {
        var _this = this;
        if (force === void 0) { force = false; }
        var self = this;
        if (force || !this.socket || this.socket.readyState !== this.readyStateConstants.OPEN) {
            this.loggerService.debug('Connecting with Web socket', this.url.url);
            try {
                self.socket = this.protocols
                    ? new WebSocket(this.url.url, this.protocols)
                    : new WebSocket(this.url.url);
                self.socket.onopen = function (ev) {
                    _this.loggerService.debug('Web socket connected', _this.url.url);
                    _this._open.next(ev);
                };
                self.socket.onmessage = function (ev) {
                    _this._message.next(JSON.parse(ev.data));
                };
                self.socket.onclose = function (ev) {
                    if ((_this.reconnectIfNotNormalClose && ev.code !== _this.normalCloseCode) ||
                        _this.reconnectableStatusCodes.indexOf(ev.code) > -1) {
                        _this.loggerService.debug('Reconnecting Web EventsSocket connection');
                        _this.reconnect();
                    }
                    else {
                        _this._close.next(ev);
                        _this._message.complete();
                    }
                };
                self.socket.onerror = function (ev) {
                    _this._error.next(ev);
                };
            }
            catch (error) {
                this.loggerService.debug('Web EventsSocket connection error', error);
                this._error.next(error);
            }
        }
    };
    WebSocketProtocol.prototype.send = function (data) {
        var _this = this;
        if (this.getReadyState() !== this.readyStateConstants.OPEN &&
            this.getReadyState() !== this.readyStateConstants.CONNECTING) {
            this.connect();
        }
        // TODO: change this for an observer
        return new Promise(function (resolve, reject) {
            if (_this.socket.readyState === _this.readyStateConstants.RECONNECT_ABORTED) {
                reject('EventsSocket connection has been closed');
            }
            else {
                _this.sendQueue.push({ message: data });
                _this.fireQueue();
            }
        });
    };
    WebSocketProtocol.prototype.fireQueue = function () {
        while (this.sendQueue.length && this.socket.readyState === this.readyStateConstants.OPEN) {
            var data = this.sendQueue.shift();
            this.socket.send(_.isString(data.message) ? data.message : JSON.stringify(data.message));
            data.deferred.resolve();
        }
    };
    WebSocketProtocol.prototype.close = function (force) {
        if (this.socket && (force || !this.socket.bufferedAmount)) {
            this.socket.close();
        }
        return this;
    };
    WebSocketProtocol.prototype.setInternalState = function (state) {
        if (Math.floor(state) !== state || state < 0 || state > 4) {
            throw new Error('state must be an integer between 0 and 4, got: ' + state);
        }
        this.internalConnectionState = state;
    };
    /**
     * Could be -1 if not initzialized yet
     * @returns {number}
     */
    WebSocketProtocol.prototype.getReadyState = function () {
        if (this.socket == null) {
            return -1;
        }
        return this.internalConnectionState || this.socket.readyState;
    };
    WebSocketProtocol.prototype.start = function () {
        this.connect();
    };
    WebSocketProtocol.prototype.destroy = function () {
        this.loggerService.debug('Closing Web EventsSocket');
        this.close(true);
    };
    return WebSocketProtocol;
}(Protocol));
export { WebSocketProtocol };
WebSocketProtocol.AVAILABLE_FOR_USER_WS_CLOSE_STATUS = 4000;
//# sourceMappingURL=websockets-protocol.js.map